import cx from 'classnames';
import { PropsWithChildren } from 'react';

import Sidebar from 'modules/Sidebar/Sidebar';

interface SidebarWrapperProps {
  contentContainerClass?: string;
}

const SidebarWrapper = ({ children, contentContainerClass }: PropsWithChildren<SidebarWrapperProps>) => (
  <div className="relative flex h-full w-full grow flex-col overflow-hidden md:flex-row">
    <Sidebar />
    <div className={cx('flex h-full w-full overflow-y-auto', contentContainerClass)}>{children}</div>
  </div>
);

export default SidebarWrapper;
